import React from 'react';
import ContainerValidation from './Components/ContainerValidation';
import HeaderValidation from './Components/HeaderValidation';
import BodyValidation from './Components/BodyValidation';
import { IconIdentityValidation} from '../../../../components/buttons/IconButtons';
import routes from '../../../../Routes/routes';
import IdentityValidationApp from './Functionality/IdentityValidationApp';
import useForbiddenValidation from './Functionality/useForbiddenValidation';
import {getUrlParameters} from "./Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const IdentityValidation = () => {
    const { id, guardFlowId, t, getUrlNext , disabledBtnNext, getInvitationById } = IdentityValidationApp();
    useForbiddenValidation({getInvitationById});
    return (
        <ContainerValidation>
            <HeaderValidation url={ getUrlParameters({ url: routes.invitationDetails.registrationProcess, id, guardFlowId })}/>

            <BodyValidation
                btnDisabled={disabledBtnNext}
                click={()=> getUrlNext() }
                textBtnNext={ disabledBtnNext ? "loading" : "next" }
            >
                <>
                    <div className="row">
                        <div className="p-0 col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("identity_validation_external")}</p>
                            <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">
                                { guardFlowId ?
                                    t("to_allow_access_visitors_identity_needs_to_be_verified")
                                    :
                                    t("identity_validation_external_subtitle")
                                }
                            </p>
                        </div>
                    </div>

                    <div className="p-0 d-flex justify-content-center align-items-center">
                        <div className="p-0 icon-identity-validation-container">
                            <IconIdentityValidation className="w-100 h-100" />
                        </div>
                    </div>

                </>
            </BodyValidation>
        </ContainerValidation>
    )

}

export default IdentityValidation
